import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { MERCHANT_REPORTS_MENU_PLANNING_ROUTE, MERCHANT_REPORTS_ROUTE } from "../../../../../../constants/routes"
import type { TranslationKey } from "../../../../../localization/translations"

import { WeekMenuTab } from "./WeekMenuTab"

type Crumb = Readonly<{
    id: TranslationKey
    label: string
    route?: string
}>

const BREADCRUMBS: ReadonlyArray<Crumb> = [
    { id: "merchant-nav-item-home", label: "Home", route: MERCHANT_REPORTS_ROUTE },
    { id: "merchant-nav-item-menu-planning", label: "Menu Planning", route: MERCHANT_REPORTS_MENU_PLANNING_ROUTE },
    { id: "merchant-menu-planning-tab-week-menu", label: "Week menu" },
]

/** Standalone route for the week menu while it has no entry point in the Menu Planning tabs. */
export function WeekMenuPage() {
    const { l10n } = useAppLocalization()

    return (
        <WeekMenuTab
            renderHeader={(actions, subtitle) => (
                <PageHeader
                    page={Page.MENU_PLANNING}
                    title={l10n.getString("merchant-menu-planning-tab-week-menu")}
                    rightElement={actions}
                    subtitleElement={subtitle}
                >
                    <StandardBreadcrumbs>
                        {BREADCRUMBS.map((crumb) => (
                            <LocalizedStrict key={crumb.id} id={crumb.id}>
                                {crumb.route ? (
                                    <BreadcrumbLink to={crumb.route}>{crumb.label}</BreadcrumbLink>
                                ) : (
                                    <Breadcrumb>{crumb.label}</Breadcrumb>
                                )}
                            </LocalizedStrict>
                        ))}
                    </StandardBreadcrumbs>
                </PageHeader>
            )}
        />
    )
}
